<template>
  <v-hover v-slot="{ hover }">
    <v-btn :small="small" :plain="plain" @click="sendCommand(command)" :disabled="disabled">
      <v-row justify="center">
        <v-col cols="12">
          <!-- <v-col cols="auto" class="d-flex justify-center" align="center"> -->
          <v-icon v-for="(item, index) in icons" :key="index" :elevation="hover ? 12 : 0" :color="hover ? 'primary' : 'secondary'"> {{ item }} </v-icon>
          <!-- </v-col> -->
          <!-- <v-col cols="auto" class="d-flex mt-1 justify-center" align="center"> -->
          <template v-if="span != ''">
            <span> {{ span }} </span>
          </template>

          <!-- </v-col> -->
        </v-col>
      </v-row>
    </v-btn>
  </v-hover>
</template>

<script>
import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "Button_ButtonHover",
  props: {
    icons: {
      type: Array,
      default() {
        return ["mdi-restore"];
      },
      require: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      require: false,
    },
    small: {
      type: Boolean,
      default: false,
      require: false,
    },
    plain: {
      type: Boolean,
      default: false,
      require: false,
    },
    command: {
      type: String,
      default: "none",
      require: false,
    },
    span: {
      type: String,
      default: "",
      require: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    sendCommand(value) {
      if (value == "") {
        return;
      }

      ServiceClient.dataCore(ServiceClient.getAPIUrl("command"), null, "?cmd=" + value, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
  },
};
</script>

<style scoped></style>
